import EmployeeTable from "./EmployeeTable";
export default EmployeeTable;
